define('views/modules/profile/blocks/custom-messages',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // collections
    'collections/conversation/custom-messages',
    // services
    'services/layout',
    'services/events/user-events',
    // views
    'views/parts/info-section',
    'views/modules/setting/personal/blocks/custom-messages/custom-messages-panel',
    // templates
    'text!templates/modules/profile/blocks/custom-messages.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    //Collection
    CCustomMessages,
    // services
    LayoutState,
    UserEvents,
    // views
    VInfoSection,
    VPersonnalCustomMessagesPanel,
    // templates
    TCustomMessages
) {

    var VPersonalInfoCustomMessages = Backbone.Epoxy.View.extend({
        template: TCustomMessages,

        events: {},

        regions: {
            count: '.count'
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.collection = new CCustomMessages();

            this.view = {
                info: new VInfoSection({
                    title: "Your custom messages",
                    icon: "sl-icon-envelope",
                    //help: "messages:helpbox-personal-info-view",
                    buttonBottom: {
                        text: "Manage your custom messagese",
                        context: this,
                        callback: this.onEditCustomMessages
                    },
                    content: this.template
                })
            };

            this.listenTo(this.collection, { 'sync': this.onCollectionSync });

        },

        render: function() {
            //var view = this.view,
            //    html = Mustache.render(this.template, Mustache.getContext(this.model.toJSON()));

            this.assign(this.view.info, this.$el) // must be first
                .applyBindings();

            this.generateZones();

            this.collection.fetch();

            //view.info.setContent(html);

            //this.applyBindings();

            return this;
        },

        _renderCount: function() {
            this.zone.$count.html(this.collection.length);
        },
        ////////////
        // events //
        ////////////

        onCollectionSync: function(collection, options) {
            this._renderCount();
        },

        onEditCustomMessages: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.edit || (view.edit = new VPersonnalCustomMessagesPanel({ model: this.model, }));
            this.trigger('panel:stack', panel);
        },

    });

    return VPersonalInfoCustomMessages;

});

